goog.provide('el8.uiwidget.ImageFeed');

goog.require('el8.uiwidget.Feed');
goog.require('el8.util.feed');


//========================================================
// UI Feed object for rendering a feed of images that
// need to be displayed in chunk so as not to potentially
// overwhelm the browser (usually can have arbitrarily
// many images)
//========================================================
el8.uiwidget.ImageFeed = function(spec) {

    // Set opts for loading images
    this._imageWidth = spec.imageWidth;
    this._imageHeight = spec.imageHeight;
    this._imageClass = spec.imageClass || null;
    this._imageWrapSelector = spec.imageWrapSelector || '.image-item-wrap';
    this._zoomable = (spec.zoomable === true);  // default false
    this._fid = spec.fid;

    // Note: we expect the "image" to be just a url
    this._indexedImageFn = spec.indexedImageFn || function(a) { return {id: a}; };

    var that = this;
    spec = spec || {};

    spec['fetchFn'] = function(arg) { return arg; };
    spec['describePageFn'] = function(page, pageCount) {
        if (page.getSize() === 1) {
            return 'Show page '+page.getEnd()+' (total '+pageCount+' pages)';
        } else {
            return 'Show pages '+(page.getStart()+1)+'-'+page.getEnd()+
                ' (total '+pageCount+' pages)';
        }
    };
    spec['addlRenderItemFn'] = function($elt) {

        if (that._imageWidth) { $elt.outerWidth(that._imageWidth); }
        if (that._imageHeight) { $elt.outerHeight(that._imageHeight); }

        // This is used to hydrate the images.. loadImage gets called here
        el8.util.feed.loadSingleImage($elt, {
            imageClass: that._imageClass,
            maxWidth: that._imageWidth,
            imageWrapSelector: that._imageWrapSelector,
            zoomable: that._zoomable,
            fid: that._fid
        });
    };

    el8.uiwidget.Feed.prototype.constructor.call(this, spec);
};
el8.uiwidget.ImageFeed.inheritsFrom(el8.uiwidget.Feed);

el8.uiwidget.ImageFeed.prototype.loadImages = function(images) {
    // Expect images to be an array of URLs, and we
    // just the URL as the image id in the feed
    this.loadIndex(images.map(this._indexedImageFn));
};
